export const ContentTypeMultipartFormData = {
  'Content-Type': 'multipart/form-data',
};
